export const replaceRouteParam = (
  route: string,
  param: string,
  value: string,
): string => {
  const regex = new RegExp(`:${param}(\\W|$)`);
  return route.replace(regex, `${value}/`);
};
